// extracted by mini-css-extract-plugin
module.exports = {"button":"HeaderCatalog_button__dHsh7","catalogButton":"HeaderCatalog_catalogButton__rdj7y"};